export enum FilterFeriasEnum {
	COM_FERIAS_MARCADAS = 0,
	SEM_FERIAS_MARCADAS = 1,
}
